import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { User, LogOut, Settings, PlusCircle, LayoutDashboard, Shield, UserPlus, Search, Coins } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CreditBalance } from '@/components/CreditBalance';

export const UserMenu = () => {
  const { user, signOut, isAuthenticated, isAdmin } = useAuth();

  if (!isAuthenticated) {
    return (
      <Link to="/auth">
        <Button variant="outline">Sign In</Button>
      </Link>
    );
  }

  const userInitials = user?.email?.substring(0, 2).toUpperCase() || 'U';

  return (
    <div className="flex items-center gap-3">
      <CreditBalance />
      <DropdownMenu>

      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full" aria-label="Open user menu">
          <Avatar className="h-8 w-8">
            <AvatarFallback className="bg-foreground text-background text-xs font-medium">
              {userInitials}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <div className="flex items-center justify-start gap-2 p-2">
          <div className="flex flex-col space-y-1 leading-none">
            <p className="font-medium">{user?.email}</p>
          </div>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/dashboard" className="flex items-center">
            <LayoutDashboard className="mr-2 h-4 w-4" />
            Dashboard
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/submit-bot" className="flex items-center">
            <PlusCircle className="mr-2 h-4 w-4" />
            Submit a Bot
          </Link>
        </DropdownMenuItem>
        {isAdmin && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to="/admin" className="flex items-center text-primary">
                <Shield className="mr-2 h-4 w-4" />
                Admin Dashboard
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/admin-setup" className="flex items-center text-primary">
                <UserPlus className="mr-2 h-4 w-4" />
                Grant Admin Access
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/discovery-settings" className="flex items-center text-primary">
                <Search className="mr-2 h-4 w-4" />
                Discovery Settings
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem asChild>
          <Link to="/profile" className="flex items-center">
            <User className="mr-2 h-4 w-4" />
            Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/settings" className="flex items-center">
            <Settings className="mr-2 h-4 w-4" />
            Settings
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/credits" className="flex items-center">
            <Coins className="mr-2 h-4 w-4" />
            Credits & Billing
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={signOut}>
          <LogOut className="mr-2 h-4 w-4" />
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
    </div>
  );
};